import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/noto-sans-devanagari/400.css';
import '@fontsource/noto-sans-devanagari/600.css';
import '@fontsource/noto-sans-devanagari/700.css';
import '@fontsource/noto-serif-devanagari/400.css';
import '@fontsource/noto-serif-devanagari/600.css';
import '@fontsource/noto-serif-devanagari/700.css';
import './index.css';
import './styles/mobile-app.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initNativeApp } from './mobile/initNativeApp';

initNativeApp();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
